<div class="carousel-sliders">
  <div class="carousel-slider" [class.disabled]="slideIndex === 0" (click)="scrollToPreviousSlide()">
    <ion-icon name="chevron-back-outline"></ion-icon>
  </div>
  <div class="carousel-slider" [class.disabled]="slideIndex === maxSlideIndex - 1" (click)="scrollToNextSlide()">
    <ion-icon name="chevron-forward-outline"></ion-icon>
  </div>
</div>

<div class="carousel-container">
  <div class="slide" *ngFor="let slide of carousel.slides; index as index">
    <div class="image-container">
      <img [appJwtSrc]="pictureURL + slide['picture_id']" />
    </div>
    <div class="slide-description">
      <span class="text">{{ slide.text }}</span>
      <span class="description">{{ slide.description }}</span>
    </div>

    <div class="alc-buttons">
      <button class="alc-button" [class.alc-message-url-button]="button.url" *ngFor="let button of slide.buttons">
        <a *ngIf="button.url; else textButton" [href]="button.url" target="_blank">
          {{ button.text }}&nbsp; <ion-icon name="open-outline"></ion-icon>
        </a>
        <ng-template #textButton>
          <span>{{ button.text }}</span>
        </ng-template>
      </button>
    </div>
  </div>
</div>

<div class="carousel-stepper">
  <div
    class="step"
    [class.selected]="slideIndex === index"
    (click)="scrollToSlide(index, true)"
    *ngFor="let step of carousel.slides; index as index"></div>
</div>
